import Core from "./Variants/Core";

const Switch = ({ name, icon, value, onChange, ...rest }) => {
  return (
    <Core name={name} value={value} onChange={onChange} icon={icon} {...rest} />
  );
};

export default Switch;
